import React, { useEffect, useState } from "react";
import { FaPlus, FaSearch, FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";

import { connect } from "react-redux";
import PActions from "../../Stores/redux/Persisted/Actions";
import UnpActions from "../../Stores/redux/Unpersisted/Actions";

import MainLayout from "../Common/MainLayout";
import DataTable from "../../Components/Table/DataTable";
import NewSchemeForm from "./NewSchemeForm";
import api from "../../Services/Api/api";
import etcModule from "../../Modules/etc/etc-module";
import { useNavigate } from "react-router-dom";

const SchemesScreen = ({ schemes, user, setScreenState }) => {
  const [filteredSchemes, setFilteredSchemes] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    load();
  }, []);

  // Filter & Search Logic
  useEffect(() => {
    let filtered = schemes.map((x) => ({
      ...x,
      office: x.office?.name,
      subdivision: x.subdivision?.name,
      block: x.block?.name,
      circle: x.circle?.name,
      lac: x.lac?.name,
      lastDate: x.lastDate ? etcModule?.toViewableDateFormat(x.lastDate) : "",
      amount: x.amount ? etcModule?.formatNumber(x.amount) : "",
    }));

    if (searchTerm) {
      filtered = filtered.filter((scheme) =>
        scheme.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredSchemes(filtered);
  }, [searchTerm, schemes]);

  const load = async () => {
    setLoading(true);
    try {
      const { schemes } = await api.get("v1/district-admin/scheme", {
        filter: JSON.stringify({
          where: { district: user.district._id },
          populate: "office subdivision block circle lac",
          sortby: "createdAt",
          order: -1,
        }),
      });
      console.log({ schemes });
      setScreenState({ schemes });
    } catch (e) {
      console.error(e);
      toast.error(e.message);
    }
    setLoading(false);
  };

  const columns = [
    { label: "Creation Date", accessor: "creationDate" },
    { label: "Name", accessor: "name" },
    { label: "Amount", accessor: "amount" },
    { label: "Last Date", accessor: "lastDate" },
    { label: "Office", accessor: "office" },
    { label: "Sub Division", accessor: "subdivision" },
    { label: "Block", accessor: "block" },
    { label: "Circle", accessor: "circle" },
    { label: "LAC", accessor: "lac" },
  ];

  return (
    <MainLayout screenName="schemes">
      <main className="projects-schemes">
        {/* Page Title & Actions */}
        <div className="page-header">
          <h1>
            Projects & Schemes{" "}
            {loading ? <FaSpinner className="spinner" /> : null}
          </h1>
          <button className="add-btn" onClick={() => setShowModal(true)}>
            <FaPlus /> Add New Scheme
          </button>
        </div>

        <div className="filters">
          <div className="search-bar">
            <FaSearch className="search-icon" />
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        {/* Table */}
        <DataTable
          columns={columns}
          data={filteredSchemes}
          searchable={false}
          emptyList={loading ? "Loading Data" : null}
          onRowClick={(item) => navigate(`/scheme/${item._id}`)}
        />

        {/* Modal for New Scheme */}
        <NewSchemeForm
          key={(!!showModal).toString()}
          {...{
            isOpen: showModal,
            onClose: () => setShowModal(false),
            onSuccess: () => load(),
          }}
        />
      </main>
    </MainLayout>
  );
};

const SCREEN_NAME = "SCHEMES_SCREEN";

const mapStateToProps = (state) => ({
  schemes: state.vState[SCREEN_NAME]?.schemes || [],
  user: state.pState.AUTH.user,
});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SchemesScreen);
